__turbopack_context__.v({
  "actionButton": "MainContentHeader-module-scss-module__5S20mG__actionButton",
  "description": "MainContentHeader-module-scss-module__5S20mG__description",
  "leftSection": "MainContentHeader-module-scss-module__5S20mG__leftSection",
  "refreshButton": "MainContentHeader-module-scss-module__5S20mG__refreshButton",
  "refreshIcon": "MainContentHeader-module-scss-module__5S20mG__refreshIcon",
  "title": "MainContentHeader-module-scss-module__5S20mG__title",
  "titleRow": "MainContentHeader-module-scss-module__5S20mG__titleRow",
  "wrapper": "MainContentHeader-module-scss-module__5S20mG__wrapper",
});
